import styled from '@emotion/styled';

import type { Material } from '../../views/orders-returns-history/orders-returns-history.types';

type MaterialsTableProps = {
  materials: Material[];
};

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.5rem;
  background-color: ${({ theme }) =>
    theme.tokens.color.alias.cm.bg['bg-neutral-subtle'].value};
  border-radius: 0.5rem;
  overflow: hidden;
`;

const TableBody = styled.tbody``;

const TableRow = styled.tr`
  border-bottom: 1px solid
    ${({ theme }) => theme.tokens.color.alias.cm.border['border-subtle'].value};

  &:last-child {
    border-bottom: none;
  }
`;

const TableCell = styled.td`
  padding: 0.25rem 0;
  font-size: 0.75rem;
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
`;

function MaterialsTable({ materials }: MaterialsTableProps): JSX.Element {
  if (!materials || materials.length === 0) {
    return <div>No materials found</div>;
  }

  return (
    <Table>
      <TableBody>
        {materials.map((material) => (
          <TableRow key={material.id}>
            <TableCell>{material.course}</TableCell>
            <TableCell>{material.name}</TableCell>
            <TableCell>{material.language}</TableCell>
            <TableCell>
              {material.totalOperationQuantity} {material.units}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export { MaterialsTable };
